<h4 *ngIf="relatedResources?.length">You May Also Like</h4>
<div
    [ngClass]="{ 'preview-grayscale': isInPreviewMode$ | async }"
    [tabindex]="(isInPreviewMode$ | async) ? -1 : 0"
    class="related-resources selenium-related-resource-item"
    *ngFor="let resource of relatedResources"
>
    <app-ymal-card
        [learningObject]="resource"
        [gtmPrefix]="gtmPrefix"
        [tabindex]="(isInPreviewMode$ | async) ? -1 : 0"
        [ngClass]="{ 'preview-grayscale': isInPreviewMode$ | async }"
    >
    </app-ymal-card>
</div>
